/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: partner-email-endpoints-editor-component.ts
 *
 * Created by rsorensen-lb on 9/28/17.
 */

'use strict';

function PartnerEmailEndpointsEditorController(
    this: JS5Object,

    _: JS5Object,
    $q: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,

    uiGridConstants: JS5Object,

    BreadcrumbService: JS5Object,
    ModalService: JS5Object,
    PartnerEditService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
    UtilsService: JS5Object) {


	//=================//
	// Lifecycle Hooks //
	//=================//

	this.$onInit = () => {
		this.loadingIndicator = {
			backdrop: true,
			show: false,
			title: 'Working',
			message: 'Please wait...'
		};

		this.canRead = false;
		this.canWrite = false;

		SidebarService.editService = PartnerEditService;
		BreadcrumbService.editService = PartnerEditService;
		this.partnerBreadcrumb = {
			location: '',
			name: '...',
			params: null,
		};

		if (BreadcrumbService.getBreadcrumbs().length < 2) {
			// add partner breadcrumb if it's not already added
			BreadcrumbService.addBreadcrumb(this.partnerBreadcrumb);
		}

		getPermissions().then(() => getEndpointEditData());
	};

	this.$postLink = () => {
		$timeout(() => {
			PartnerEditService.editorForm = this.editorForm;
		});
	};


	//======//
	// Data //
	//======//

	const getPermissions = () => {
		const emailEndpointsViewState = 'SYSTEM_PARTNERS_EMAIL_VIEW_STATE';

		return $q.all({
			canRead: PermissionsService.canRead(emailEndpointsViewState),
			canWrite: PermissionsService.canWrite(emailEndpointsViewState),
		}).then((permissions: JS5Object) => {
			this.canRead = permissions.canRead;
			this.canWrite = permissions.canWrite;
		});
	};

	const setBreadcrumbData = () => {
		this.partnerBreadcrumb.location =
			'/system/partners/edit/' +
			this.partnerObject.id +
			'/emailEndpoints';
		this.partnerBreadcrumb.name = this.partnerObject.name;
		this.breadcrumbName = this.endpointObject.name || 'New Email Endpoint';
	};

	const getEndpointEditData = () => {
		if (this.canRead) {
			this.loadingIndicator.show = true;
			PartnerEditService.getEmailEndpointEditData().then((data: JS5Object) => {
				this.partnerObject = data.partnerObject;
				this.availableDeliveryTemplates = this.partnerObject.deliveryTemplates;
                this.endpointObject = data.endpointObject;
				this.availableEmailTemplates = data.availableEmailTemplates;

				if (!this.endpointObject.id) {
					this.editorForm.$setDirty();
				}

				setBreadcrumbData();

				// loading indicator won't shut off without
				// wrapping this in a $timeout() ...?
				$timeout(() => {
					this.loadingIndicator.show = false;
				});
			})
		}
	};


	//================//
	// Template Logic //
	//================//

	this.getDeliveryTemplateName = (deliveryTemplate: JS5Object) => {
		return deliveryTemplate.template.name;
	};

	this.reqdFieldsArePopulated = () => {
		let reqdFields = [
			'name',
			'emailTemplate',
			'subjectExpression',
		];

		return reqdFields.reduce((accum, field) => {
			return accum && UtilsService.hasData(this.endpointObject[field]);
		}, true);
	};


	//=================//
	// Toolbar Buttons //
	//=================//

	this.toolbarButtonDefs = [
		{
			label: 'Save',
			enabled: (): boolean => this.editorForm.$dirty && this.canWrite && this.reqdFieldsArePopulated(),
			onClick: () => {
				this.loadingIndicator.show = true;
				PartnerEditService.saveEmailEndpoint(this.endpointObject).then((newEndpointObject: JS5Object) => {
                    this.endpointObject = newEndpointObject;
					$route.updateParams({endpointId: this.endpointObject.id});
					setBreadcrumbData();
					this.loadingIndicator.show = false;
				});
			},
		},
		{
			label: 'Revert',
			enabled: (): boolean => this.editorForm.$dirty,
			onClick: () => {
				PartnerEditService.revertEmailEndpoint(this.partnerBreadcrumb.location);
                this.endpointObject = PartnerEditService.endpointObject;
				setBreadcrumbData();
			},
		},
		{
			label: 'Close',
			enabled: (): boolean => true,
			onClick: () => PartnerEditService.exitEdit(this.partnerBreadcrumb.location),
		}
	];
}

angular
.module('prism-ui.partner')
.component('partnerEmailEndpointsEditor', {
	templateUrl: 'system/partner/editor/components/view/emailEndpoints/editor/partner-email-endpoints-editor-template.html',
	controller: PartnerEmailEndpointsEditorController,
	bindings: {
    }
});
